import PropTypes from 'prop-types';
import styled from 'styled-components';

import { ReactComponent as LockIcon } from '../../assets/images/svg/lock-2.svg';
import themeColors from '../../assets/styles/themeColors';

const VaultLockStyled = styled.div`
  width: ${({ w }) => w};
  height: ${({ h }) => h};
  border-radius: 100%;
  background-color: ${themeColors.colorBackgroundPrimaryDark};
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 28px;
    fill: ${({ color }) => color || themeColors.colorTextPrimary};
  }
`;

const VaultLock = (props) => (
  <VaultLockStyled {...props}>
    <LockIcon />
  </VaultLockStyled>
);

VaultLock.propTypes = {
  w: PropTypes.string,
  h: PropTypes.string,
  color: PropTypes.string,
};

VaultLock.defaultProps = {
  w: '62px',
  h: '62px',
};

export default VaultLock;
